import { Button, Typography, Fade, TextField, Box, ButtonGroup } from '@mui/material';
import { useSnackbar } from 'notistack';
import { FC, useState } from 'react';
import { Modal, Loader } from '..';
import { turnOffFeatureFlag } from '../../fetch';
import { truncString } from '../../helpers';
import { FeatureFlag } from '../../models';
const { LegacySystem } = require('../../buildSettings.json');

export interface SwitchToLegacyModalProps {
  isOpen: boolean;
  onClose: () => void;
  requiredFeature: FeatureFlag;
  legacyUrl: string;
}

export const SwitchToLegacyModal: FC<SwitchToLegacyModalProps> = ({
  isOpen,
  onClose,
  requiredFeature,
  legacyUrl
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [reason, setReason] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    setReason('');
    setIsSubmitting(false);
    onClose();
  };

  const onSubmit = async () => {
    try {
      setIsSubmitting(true);
      const redirectLink = legacyUrl ?? `${LegacySystem}`;
      const currentUrl = window.location.href;
      await turnOffFeatureFlag(requiredFeature, reason, truncString(currentUrl, 500));
      window.location.href = redirectLink;
      enqueueSnackbar('Redirecting...', {
        variant: 'info'
      });
    } catch (error) {
      enqueueSnackbar(error?.Detail ?? 'Error submitting reason, please try again.', {
        variant: 'error'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={handleClose} title="Reason" maxWidth="xs">
      {isSubmitting && <Loader type="overlay" position="centered" />}
      <Fade in={isOpen}>
        <Box mt={0.5}>
          <Typography gutterBottom>
            Please provide a reason you are going back to the legacy version of the site.
          </Typography>
          <Box mb={1} mt={1}>
            <TextField
              label="Reason"
              fullWidth
              size="small"
              name=""
              multiline
              rows={3}
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
          </Box>
          <ButtonGroup sx={{ gap: '10px' }}>
            <Button variant="contained" color="primary" disabled={!reason} onClick={onSubmit}>
              Submit
            </Button>
            <Button variant="contained" color="inherit" onClick={handleClose}>
              Cancel
            </Button>
          </ButtonGroup>
        </Box>
      </Fade>
    </Modal>
  );
};
